export default "__VITE_ASSET__3MQk7nf0__"